
import {SET_SALES_REP} from '../actions/sales-rep';
const initialState = {
    sales_rep_name: null,
    sales_rep_phone: null
};
const sales_rep = (state = initialState, action) => {
    switch(action.type)
    {
        case SET_SALES_REP : 
        return action.payload
        default:
        return state;
    }
};

export default sales_rep;


// WEBPACK FOOTER //
// ./src/store/reducers/sales-rep.js